<template>
	<div class='inspection-geometry'>
		<div class='flex-container'>
			<div>
				<LoadAbrisBlock/>

				<AddBlock class='add-block-outer'/>

				<div v-if='!pointList.length'>
					<span>Координаты участка еще не добавлены</span>
				</div>

				<table v-else class='table-def table-points'>
					<thead>
						<tr>
							<th>№</th>
							<th>Широта</th>
							<th>Долгота</th>
							<th><button @click='removeAll' :disabled='!actLpoIsDraft'>удалить все</button></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for='point in pointList' :key='point.id'>
							<td>{{ point.point_num }}</td>
							<td>{{ point.lat }}</td>
							<td>{{ point.lon }}</td>
							<td><button class='remove-btn' @click='remove(point)' :disabled='!actLpoIsDraft'>удалить</button></td>
						</tr>
					</tbody>
				</table>

				<LoadCoordBlock/>

				<SBlock v-if='selectedLpo && selectedLpo.section_lp' class='s-block-outer'/>

			</div>

			<div class='map-container flex-item'>
				<MapComponent :abris-points='pointList' ref='map'/>
			</div>

		</div>

		<!-- <div class='map-container'>
			<MapComponent :abris-points='pointList' ref='map'/>
		</div> -->

	</div>
</template>

<script>
	import { mapActions } from 'vuex';
	import LoadAbrisBlock from './CurrentLpoGeometry__loadAbris';
	import LoadCoordBlock from './CurrentLpoGeometry__loadCoords';
	import AddBlock from './CurrentLpoGeometry__addPoint';
	import SBlock from './CurrentLpoGeometry__s';
	import MapComponent from '../../MapComponent';

	export default {
		name: 'SelectedLpoGeometry',
		components: {
			LoadAbrisBlock,
			LoadCoordBlock,
			AddBlock,
			SBlock,
			MapComponent
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			selectedLpo() {
				return this.$store.state.selectedLpo.lpo;
			},

			pointList() {
				return this.$store.state.selectedLpo['pointList'];
			},

			map() {
				return this.$refs['map'];
			}
		},

		watch: {
			pointList(val) {
				this.updateLpo();
			}
		},

		methods: {

			remove(point) {
				this.removePoint(point).then(res => {
					this.updatePointList();
				});
			},

			removeAll() {
				const confirmation = confirm('Удалить все координаты?');
				if (!confirmation) {
					return;
				}

				this.removeAllLpoPoints().then(res => {
					this.updatePointList();
				});
			},

			...mapActions('selectedLpo', [
				'updatePointList',
				'removePoint',
				'removeAllLpoPoints',
				'updateLpo'
			])
		}
	};
</script>

<style scoped src='@/style/flex.css'></style>
<style scoped src='@/style/table.css'></style>

<style scoped>
	.flex-container {
		gap: 20px;
	}

	.table-points {
		width: 400px;
		margin-top: 40px;
	}

	.add-block-outer {
		width: 400px;
	}

	.s-block-outer {
		margin-top: 30px;
	}
</style>